"use client";

import React, { useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import { Divider } from "antd";
import Banner from "@/components/shared/Banner";
import { get } from "lodash";

export default function ProductSlider({ products = [] }) {
  const productsSliderRef = useRef(null);

  const swiperProductsOption = {
    spaceBetween: 24,
    speed: 2000,
    autoplay: false,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
  };

  const getProductName = (product) => {
    return product.name || "";
  };

  const getProductDescription = (product) => {
    return product.description || "";
  };

  return (
    <div className="relative w-full z-10 product-slider">
      <div className="flex flex-row items-center xl:pt-16">
        {products && products.length > 0 && (
          <Banner
            ref={productsSliderRef}
            slides={products}
            style={{ minHeight: "200px" }}
            controls={{ withNavigation: true, withPagination: false }}
            options={swiperProductsOption}
          >
            {({ slide: { item, index } }) => (
              <Link
                href={`/products/${item.id}`}
                className={`bg-1 px-6 rounded-md pt-12 pb-4 flex flex-col h-fit shadow-3xl maxMb:border maxMb:border-gray-2 product-item relative z-10 ${
                  (index + 1) % 2 === 0 ? "md:-mt-25 bg-2" : ""
                }`}
              >
                <Image
                  loading="lazy"
                  src={
                    get(item, "thumbnail.source") ||
                    item.thumbnail ||
                    "/images/default.jpg"
                  }
                  className="w-full rounded-md max-h-[270px] object-cover"
                  alt={getProductName(item)}
                  width={300}
                  height={270}
                />
                <div className="mt-9">
                  <div className="font-bold text-prim-90 text-2xl">
                    {getProductName(item)}
                  </div>
                  <div className="flex items-center gap-x-4">
                    <span className="text-prim-80 flex-none underline decoration-prim-80 font-medium">
                      Xem chi tiết
                    </span>
                    <Divider className="bg-orange-90" />
                  </div>
                </div>
                <div className="bg-hover opacity-0 flex flex-col justify-start rounded-md absolute top-0 right-0 left-0 bottom-0 info-product text-white py-4 px-6">
                  <div className="font-bold text-2xl mb-5">
                    {getProductName(item)}
                  </div>
                  <div className="text-base xl:text-sm">
                    {getProductDescription(item)}
                  </div>
                  <div className="text-white flex flex-row items-center flex-wrap gap-x-6 mt-auto">
                    <Image
                      loading="lazy"
                      className="xl:w-auto"
                      src="/images/icons/right-arrow.png"
                      alt={getProductName(item)}
                      width={24}
                      height={24}
                    />
                    <span className="xl:w-auto !underline transition-all duration-300">
                      Xem chi tiết
                    </span>
                  </div>
                </div>
              </Link>
            )}
          </Banner>
        )}
      </div>
    </div>
  );
}
